import type { DeepQueryParams, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { wpApi } from '@gik/core/api/ky/wpApi';
import { useWPApi } from '@gik/core/api/swr/useWPApi';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import PostsUrlBuilder from './PostsUrlBuilder';

const path = 'posts';

function getParams(slug: string): DeepQueryParams {
  // prettier-ignore
  return new PostsUrlBuilder()
    .byAuthor(slug)
    .withAllPages(true)
    .params;
}

export function getAuthorPosts(slug: string) {
  return wpApi
    .get(path, {
      searchParams: getParams(slug),
    })
    .json<WordpressPost[]>();
}

export function useAuthorPosts(slug: string, config?: SWRConfigInterface) {
  return useWPApi<WordpressPost[]>(path, getParams(slug), config);
}
